import React, { useState } from 'react'
import Menu from '@mui/material/Menu'

import menuIcon from '../../../../assets/img/icons/table-menu.png'
import changeStatusImage from '@/assets/img/storage/icons/change-status.svg'
import acceptImage from '@/assets/img/storage/icons/accept.svg'
import cancelImage from '@/assets/img/storage/icons/cancel.svg'
import { trans } from '../../../../_providers/Translation'

function OptionsOnlineSales(props) {

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {
        e.stopPropagation()

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleConfirm = () => {
        handleCloseMenu()
        props.handleConfirm(props.id)
    }

    const handleReject = () => {
        handleCloseMenu()
        props.handleReject(props.id)
    }

    const handleChangeStatus = () => {
        handleCloseMenu()
        props.handleChangeStatus(props.id)
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >
                {props.status === 'pending'
                    ?
                    [
                        <div className="menu-option" key="confirm" onClick={handleConfirm}>
                            <img src={acceptImage} alt="accept" />{trans('buttons.confirm')}
                        </div>,
                        <div className="menu-option" key="reject" onClick={handleReject}>
                            <img src={cancelImage} alt="cancel" />{trans('buttons.reject')}
                        </div>
                    ]
                    :
                    <div className="menu-option" onClick={handleChangeStatus}>
                        <img src={changeStatusImage} alt="change status" />
                        {trans('buttons.changeStatus') || 'Change Status'}
                    </div>
                }
            </Menu>
        </>
    )
}

export default OptionsOnlineSales
